//@flow
import React from 'react';

type Props = {
  onClick: (e: MouseEvent) => any,
};

export default function ButtonFileStorage(props: Props) {
  const { onClick } = props;
  return (
    <div className="float-right">
      <button
        type="button"
        data-toggle="modal"
        data-target="#file-storage-modal"
        className="btn-show-member"
        id="btn-file-storage"
        onClick={onClick}
      >
        <i className="fas fa-file-alt" />
      </button>
    </div>
  );
}
